import PropTypes from 'prop-types'
import { CaretUp, CaretDown } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { platformInfo } from './helpers'
import Stars from './Stars'

const Platforms = ({ providerRating = [] }) => {
  const { t } = useTranslation(['organisation'])
  return (
    <div className="reputation-dashboard-tab__platforms">
      <h4 className="reputation-dashboard-tab__overview-title">
        {t('organisation:reputationManagement.platformsTitle')}
      </h4>
      <div className="platforms row-view">
        {providerRating.map((option, index, arr) => (
          <div key={index} className={`platforms__item ${arr.length <= 3 ? 'row-view' : ''}`}>
            <div className="platforms__item--part">
              <img src={platformInfo[option.provider]?.iconPng} />
              <h3>{platformInfo[option.provider]?.label}</h3>
            </div>
            <div className="platforms__item--part">
              <div className="platforms__item--rating">
                <h4>{option.avgRating}</h4>
                <Stars starsValue={0} starsTotal={1} />
                <p className={option.reviewCountDiff >= 0 ? 'increase' : 'decrease'}>
                  {option.reviewCountDiff >= 0 ? (
                    <CaretUp size={12} weight="fill" />
                  ) : (
                    <CaretDown size={12} weight="fill" />
                  )}
                  {Math.abs(option.reviewCountDiff)}
                </p>
              </div>
              <p>
                {t('organisation:reputationManagement.platforms.reviewsCountTrailingSpace', {
                  count: option.reviewCount,
                })}
              </p>
              <p>
                (
                <span>
                  {option.reviewCountDiff >= 0 ? '+' : '-'}
                  {t('organisation:reputationManagement.platforms.reviewsCount', {
                    count: Math.abs(option.reviewCountDiff),
                  })}
                </span>
                )
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

Platforms.propTypes = {
  providerRating: PropTypes.array,
}

export default Platforms
